
const ColorSquare = ({ color }) => (
  <div
    style={{
      width: 20,
      height: 20,
      backgroundColor: color,
      display: 'inline-block',
    }}
  />
);

export default ColorSquare;
